export enum InviteFlowLocalStorage {
    UserStartedInviteFlow = 'UserStartedInviteFlow',
    UserInvitedPod = 'UserInvitedPod',
}
